import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../../models/notification.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  public nortificationDisplayTime = 2500;

  private _notification$ = new Subject<Notification>();
  notification$ = this._notification$.asObservable();

  public timeout = 5000;
  public maxNotifications = 2;

  constructor(private _snackBar: MatSnackBar) {}

  show(type: Notification['type'], message: string) {
    this._notification$.next({ type, message });
  }

  showAlertMessage(message: string) {
    this._snackBar.open(message, 'x', {
      duration: this.nortificationDisplayTime,
      panelClass: ['mat-snackbar-alert-class'],
      verticalPosition: 'top',
    });
  }
  showSuccessMessage(message: string) {
    this._snackBar.open(message, 'x', {
      duration: this.nortificationDisplayTime,
      panelClass: ['mat-snackbar-success-class'],
      verticalPosition: 'top',
    });
  }
}